import { Request } from "@/plugin/axios";
import { message } from "ant-design-vue";
import api from "@/constant/api/console/model/model-definition";
import store from "@/store";

// 新增属性
export function addNewProperty(params, options) {
  return Request(api.addNewProperty, api.addNewProperty.url, params, options);
}

export function getStandardProperty(params, options) {
  return Request(api.getStandardProperty, api.getStandardProperty.url, params, options);
}

export function getCustomProperty(params, options) {
  return Request(api.getCustomProperty, api.getCustomProperty.url, params, options);
}

export function updateProperty(params, options) {
  return Request(api.updateProperty, api.updateProperty.url, params, options).then((res) => {
    if (res.success) {
      message.success("保存成功");
    }
    return res;
  });
}

// export function releasedProperty(id) {
//   return Request(api.releasedProperty, `${api.releasedProperty.url}/${id}`).then((res) => {
//     if (res.success) {
//       message.success("发布成功");
//     }
//     return res;
//   });
// }

export function getUnitList(params) {
  return Request(api.getUnitList, api.getUnitList.url, params);
}

export function deleteProperty(id) {
  return Request(api.deleteProperty, `${api.deleteProperty.url}/${id}`).then((res) => {
    if (res.success) {
      message.success("删除成功");
    }
    return res;
  });
}

// 根据属性ID查询所属功能
export function getFunByProp(id) {
  return Request(api.getFunByProp, `${api.getFunByProp.url}/${id}`);
}

// 根据属性ID查询属性详情
export function getPropById(id) {
  return Request(api.getPropById, `${api.getPropById.url}/${id}`).then((res) => {
    return res.data;
  });
}
// 根据属性ID查询属性详情
export function getStandardPropById(id) {
  return Request(api.getStandardPropById, `${api.getStandardPropById.url}/${id}`).then((res) => {
    return res.data;
  });
}

// --------------指令部分 ----------

// 新增指令
export function addNewCommand(params, options) {
  return Request(api.addNewCommand, api.addNewCommand.url, params, options).then((res) => {
    if (res.success) {
      message.success("新增成功");
    }
    return res;
  });
}
// 指令版本撤销
export function commandRevokeReleased(id) {
  return Request(api.commandRevokeReleased, `${api.commandRevokeReleased.url}/${id}`);
}

// 编辑指令
export function updateCommand(params, options) {
  return Request(api.updateCommand, api.updateCommand.url, params, options).then((res) => {
    if (res.success) {
      message.success("保存成功");
    }
    return res;
  });
}

// 获取自定义指令列表
export function getCustomCommandList(params, options) {
  return Request(api.getCustomCommandList, api.getCustomCommandList.url, params, options);
}
// 获取标准指令列表
export function getStandardCommandList(params, options) {
  return Request(api.getStandardCommandList, api.getStandardCommandList.url, params, options);
}

// 根据指令ID查询指令详情
export function getCommandById(id) {
  return Request(api.getCommandById, `${api.getCommandById.url}/${id}`).then((res) => {
    return res.data;
  });
}
export function getStandardCommandById(id) {
  return Request(api.getStandardCommandById, `${api.getStandardCommandById.url}/${id}`).then(
    (res) => {
      return res.data;
    }
  );
}

// 发布指令
export function releasedCommand(id) {
  return Request(api.releasedCommand, `${api.releasedCommand.url}/${id}`).then((res) => {
    if (res.success) {
      message.success("发布成功");
    }
    return res;
  });
}
// 删除指令
export function deleteCommand(id) {
  return Request(api.deleteCommand, `${api.deleteCommand.url}/${id}`).then((res) => {
    if (res.success) {
      message.success("删除成功");
    }
    return res;
  });
}
// 根据指令ID查询所属功能
export function getFunByCommand(id) {
  return Request(api.getFunByCommand, `${api.getFunByCommand.url}/${id}`);
}
// 元件所属自定义功能版本分页查询
export function getCustomFunctionByMember(params, options) {
  return Request(api.getCustomFunctionByMember, api.getCustomFunctionByMember.url, params, options);
}
export function getStandardFunctionByMember(params, options) {
  return Request(
    api.getStandardFunctionByMember,
    api.getStandardFunctionByMember.url,
    params,
    options
  );
}

// --------------事件部分-------------

// 新增事件
export function addNewEvent(params, options) {
  return Request(api.addNewEvent, api.addNewEvent.url, params, options).then((res) => {
    if (res.success) {
      message.success("新增成功");
    }
    return res;
  });
}

// 编辑事件
export function updateEvent(params, options) {
  return Request(api.updateEvent, api.updateEvent.url, params, options).then((res) => {
    if (res.success) {
      message.success("保存成功");
    }
    return res;
  });
}

// 删除事件
export function deleteEvent(id) {
  return Request(api.deleteEvent, `${api.deleteEvent.url}/${id}`).then((res) => {
    if (res.success) {
      message.success("删除成功");
    }
    return res;
  });
}
// 获取事件列表
export function getStandardEventList(params, options) {
  return Request(api.getStandardEventList, api.getStandardEventList.url, params, options);
}
export function getCustomEventList(params, options) {
  return Request(api.getCustomEventList, api.getCustomEventList.url, params, options);
}

// 根据事件ID查询事件详情
export function getEventById(id) {
  return Request(api.getEventById, `${api.getEventById.url}/${id}`).then((res) => {
    return res.data;
  });
}
// 根据事件ID查询事件详情
export function getStandardEventById(id) {
  return Request(api.getStandardEventById, `${api.getStandardEventById.url}/${id}`).then((res) => {
    return res.data;
  });
}

// 发布事件
export function releasedEvent(id) {
  return Request(api.releasedEvent, `${api.releasedEvent.url}/${id}`).then((res) => {
    if (res.success) {
      message.success("发布成功");
    }
    return res;
  });
}
// 根据事件ID查询所属功能
export function getFunByEvent(id) {
  return Request(api.getFunByEvent, `${api.getFunByEvent.url}/${id}`);
}

// --------------功能部分-------------
// 新增功能
export function addNewFunc(params, options) {
  return Request(api.addNewFunc, api.addNewFunc.url, params, options);
}

// 编辑功能
export function updateFunc(params, options) {
  return Request(api.updateFunc, api.updateFunc.url, params, options).then((res) => {
    if (res.success) {
      message.success("保存成功");
    }
    return res;
  });
}

// 分页查询功能列表
export function getStandardFunList(params, options) {
  return Request(api.getStandardFunList, api.getStandardFunList.url, params, options);
}
export function getCustomFunList(params, options) {
  return Request(api.getCustomFunList, api.getCustomFunList.url, params, options);
}

// 删除功能
export function deleteFun(id) {
  return Request(api.deleteFun, `${api.deleteFun.url}/${id}`).then((res) => {
    if (res.success) {
      message.success("删除成功");
    }
    return res;
  });
}

// 发布功能
export function releasedFun(id) {
  return Request(api.releasedFun, `${api.releasedFun.url}/${id}`).then((res) => {
    if (res.success) {
      message.success("发布成功");
    }
    return res;
  });
}
export function getStandardMembersByVerId(id) {
  return Request(api.getStandardMembersByVerId, `${api.getStandardMembersByVerId.url}/${id}`);
}
export function getCustomMembersByVerId(id) {
  return Request(api.getCustomMembersByVerId, `${api.getCustomMembersByVerId.url}/${id}`);
}

// 根据identifier、name查询功能列表
export function getFunctionList(params) {
  return Request(api.getFunctionList, api.getFunctionList.url, params).then((res) => res.data);
}
// 标准功能版本列表查询
export function getFunctionVerList(params) {
  return Request(api.getFunctionVerList, api.getFunctionVerList.url, params).then(
    (res) => res.data
  );
}
// 根据功能id查询历史版本列表
export function getFunctionHistoryListById(id) {
  return Request(api.getFunctionHistoryListById, `${api.getFunctionHistoryListById.url}/${id}`);
}

// 功能版本撤销发布
export function revokeReleased(id) {
  return Request(api.revokeReleased, `${api.revokeReleased.url}/${id}`);
}
// -----------------产品部分-------------------
// 发布产品版本
export function releasedProd(id) {
  return Request(api.releasedProd, `${api.releasedProd.url}/${id}`).then((res) => {
    if (res.success) {
      message.success("发布成功");
    }
    return res;
  });
}
// 删除产品
export function deleteProd(id) {
  return Request(api.deleteProd, api.deleteProd.url + "/" + id).then((res) => {
    if (res.success) {
      message.success("删除成功");
    }
  });
}
// 查看功能物模型
export function queryModelJson(params) {
  return Request(api.queryModelJson, api.queryModelJson.url, params);
}
// 产品信息变更
export function changeProductInfo(params) {
  return Request(api.changeProductInfo, api.changeProductInfo.url, params);
}
// 查询产品历史版本
export function getProductHistoryList(productId) {
  return Request(api.getProductHistoryList, `${api.getProductHistoryList.url}/${productId}`);
}

// ---------------规则校验-------------------------
// 校验属性指令事件的标识符是否唯一
export function memberIdentifierCheck(params) {
  params.instanceId = store.state.user.userInfo.userId;
  return Request(api.memberIdentifierCheck, api.memberIdentifierCheck.url, params, {
    hideError: true
  });
}

// 校验属性指令事件的名称是否唯一
export function memberNameCheck(params) {
  params.instanceId = store.state.user.userInfo.userId;
  return Request(api.memberNameCheck, api.memberNameCheck.url, params, {
    hideError: true
  });
}

// 校验功能的标识符是否唯一
export function funcIdentifierCheck(params) {
  return Request(api.funcIdentifierCheck, api.funcIdentifierCheck.url, params, {
    hideError: true
  });
}

// 校验功能的名称是否唯一
export function funcNameCheck(params) {
  return Request(api.funcNameCheck, api.funcNameCheck.url, params, {
    hideError: true
  });
}

export function getStandardReferencedProduct(data, options) {
  return Request(
    api.getStandardReferencedProduct,
    api.getStandardReferencedProduct.url,
    data,
    options
  );
}
export function getCustomReferencedProduct(data, options) {
  return Request(api.getCustomReferencedProduct, api.getCustomReferencedProduct.url, data, options);
}
